import { MailingEffects } from './effects/mailing.effects';
import { NotificationEffects } from './effects/notification.effects';


export const effects = [
    MailingEffects,
    NotificationEffects,
];
